import AnalysisControlBase from './AnalysisControlBase';

export default class SpatialIntersectionAnalysisControl extends AnalysisControlBase {
    _getPanelTitle() {
        return this.resourcesHandler.get('SpatialIntersectionAnalysis_PanelTitle');
    }

    _getFormBody() {
        const r = this.resourcesHandler;
        return `${this._section('AnalysisSection_Sources')}
                <div class="form-group col-6 mb-1">
                    <div class="col-12 mb-3">
                        <div class="form-group">
                            <label class="form-label">${r.get('JoinAnalysis_Source1')}:</label>
                            <input class="form-control" id="${this._id('first-source')}">
                        </div>
                    </div>
                    <div class="col-12 mb-3">
                        <div class="form-group">
                            <label class="form-label">${r.get('SpatialIntersectionAnalysis_Source1Geom')}:</label>
                            <input class="form-control" id="${this._id('first-source-fields')}">
                        </div>
                    </div>
                </div>
                <div class="form-group col-6 mb-1">
                    <div class="col-12 mb-3">
                        <div class="form-group">
                            <label class="form-label">${r.get('JoinAnalysis_Source2')}:</label>
                            <input class="form-control" id="${this._id('second-source')}">
                        </div>
                    </div>
                    <div class="col-12 mb-3">
                        <div class="form-group">
                            <label class="form-label">${r.get('SpatialIntersectionAnalysis_Source2Geom')}:</label>
                            <input class="form-control" id="${this._id('second-source-fields')}">
                        </div>
                    </div>
                </div>
                ${this._section('AnalysisSection_Options')}
                <div class="form-group col-12 mb-0 d-flex">
                    <div class="col-6 mb-3">
                        <div class="form-group">
                            <label class="form-label">${r.get('SpatialIntersectionAnalysis_Operator')}:</label>
                            <input class="form-control" id="${this._id('spatial-operator')}">
                        </div>
                    </div>
                    <div class="col-6 mb-3">
                        <div class="form-group">
                            <label class="form-label">${r.get('JoinAnalysis_JoinType')}:</label>
                            <input class="form-control" id="${this._id('join-type')}">
                        </div>
                    </div>
                </div>
                <div class="form-group col-12 mb-1 d-flex">
                    <div class="col-6 mb-3 align-content-center pt-4">
                        <div class="form-group" style="display: flex; flex-direction: row-reverse; height: 1.2rem; justify-content: flex-end;">
                            <label class="form-label ml-1">${r.get('SpatialIntersectionAnalysis_IncludeIntersectionGeom')}</label>
                            <div id="${this._id('include-intersection-geom')}"></div>
                        </div>
                    </div>
                </div>
                ${this._section('AnalysisSection_TargetFields')}
                <div class="form-group col-6 mb-1" id="${this._id('first-source-target-fields')}">
                </div>
                <div class="form-group col-6 mb-1" id="${this._id('second-source-target-fields')}">
                </div>
                ${this._section('AnalysisSection_Output')}
                <div class="form-group col-12 mb-1 d-flex">
                    <div class="col-6 mb-3">
                        <div class="form-group">
                            <label class="form-label">${r.get('Analysis_ResultLayerName')}:</label>
                            <input class="form-control" type="text" id="${this._id('analysis-name')}">
                        </div>
                    </div>
                    <div class="col-6 mb-3">
                        <div class="form-group">
                            <label class="form-label">${r.get('Analysis_ResultPkField')}:</label>
                            <input class="form-control" id="${this._id('analysis-pk-field')}">
                        </div>
                    </div>
                </div>
                <div class="form-group col-12 mb-1 d-flex">
                    <div class="col-6 mb-3">
                        <div class="form-group">
                            <label class="form-label">${r.get('Analysis_ResultGeomField')}:</label>
                            <input class="form-control" id="${this._id('analysis-geom-field')}">
                        </div>
                    </div>
                    <div class="col-6 mb-3 align-content-center pt-4">
                        <div class="form-group" style="display: flex; flex-direction: row-reverse; height: 1.2rem; justify-content: flex-end;">
                            <label class="form-label ml-1">${r.get('Analysis_SpatialFilter')}</label>
                            <div id="${this._id('spatial-filter')}"></div>
                        </div>
                    </div>
                </div>`;
    }

    _wireWizardEvents() {
        const r = this.resourcesHandler;

        this._$('first-source').kendoComboBox(this._entityComboOptions((entity, fields) => {
            this._renderTargetFields(true, fields);
            const geomFields = fields.filter(f => f.DataType === 'GEOMETRY' || f.DataType == null);
            this._setComboData('first-source-fields', geomFields);
        }));

        this._$('second-source').kendoComboBox(this._entityComboOptions((entity, fields) => {
            this._renderTargetFields(false, fields);
            const geomFields = fields.filter(f => f.DataType === 'GEOMETRY' || f.DataType == null);
            this._setComboData('second-source-fields', geomFields);
        }));

        this._$('first-source-fields').kendoComboBox(this._fieldsComboOptions());
        this._$('second-source-fields').kendoComboBox(this._fieldsComboOptions());

        this._$('spatial-operator').kendoComboBox({
            dataTextField: 'Name',
            dataValueField: 'Id',
            filter: 'contains',
            syncValueAndText: false,
            suggest: true,
            ignoreCase: true,
            dataSource: [
                { Id: 'INTERSECTS', Name: r.get('SpatialOperator_Intersects') },
                { Id: 'CONTAINS', Name: r.get('SpatialOperator_Contains') },
                { Id: 'CONTAINED_BY', Name: r.get('SpatialOperator_ContainedBy') }
            ]
        });

        this._$('join-type').kendoComboBox({
            dataTextField: 'Name',
            dataValueField: 'Id',
            filter: 'contains',
            syncValueAndText: false,
            suggest: true,
            ignoreCase: true,
            dataSource: [
                { Id: 'Inner', Name: 'Inner' },
                { Id: 'Left', Name: 'Left' },
                { Id: 'Right', Name: 'Right' },
                { Id: 'Outer', Name: 'Outer' }
            ]
        });

        this._$('analysis-pk-field').kendoComboBox(this._fieldsComboOptions());
        this._$('analysis-geom-field').kendoComboBox(this._fieldsComboOptions());

        const switchMessages = {
            checked: this.resourcesHandler.get('Yes'),
            unchecked: this.resourcesHandler.get('No')
        };

        this._$('include-intersection-geom').kendoSwitch({
            messages: switchMessages,
            checked: false,
            change: () => this._refreshPkGeomChoices()
        });

        this._$('spatial-filter').kendoSwitch({
            messages: switchMessages,
            checked: false
        });
    }

    _addExtraPkGeomItems(dataSource) {
        const includeSwitch = this._$('include-intersection-geom').data('kendoSwitch');
        if (includeSwitch == null || !includeSwitch.check()) {
            return;
        }
        const firstEntity = this._selectedRow('first-source');
        const secondEntity = this._selectedRow('second-source');
        if (firstEntity == null || secondEntity == null) {
            return;
        }
        const name = this._intersectionOutputName(firstEntity, secondEntity);
        dataSource.push({ Id: name, FieldName: name, DataType: 'GEOMETRY' });
    }

    _intersectionOutputName(firstEntity, secondEntity) {
        return firstEntity.Key + '_' + secondEntity.Key + '_Intersection';
    }

    _defaultLayerName() {
        const first = this._selectedRow('first-source');
        const second = this._selectedRow('second-source');
        if (first == null || second == null) {
            return '';
        }
        return first.Name + '-' + second.Name + '-Intersection';
    }

    _validate() {
        const errors = [
            this._vCombo('first-source', 'JoinAnalysis_Source1'),
            this._vCombo('first-source-fields', 'SpatialIntersectionAnalysis_Source1Geom'),
            this._vCombo('second-source', 'JoinAnalysis_Source2'),
            this._vCombo('second-source-fields', 'SpatialIntersectionAnalysis_Source2Geom'),
            this._vCombo('spatial-operator', 'SpatialIntersectionAnalysis_Operator'),
            this._vCombo('join-type', 'JoinAnalysis_JoinType'),
            this._vCombo('analysis-pk-field', 'Analysis_ResultPkField'),
            this._vCombo('analysis-geom-field', 'Analysis_ResultGeomField')
        ];
        // e nevoie de cel puțin o ieșire: un câmp țintă sau geometria intersecției
        const hasTarget = $('#' + this.panelId + ' .target-field-items:checked').length > 0;
        const includeIntersection = this._$('include-intersection-geom').data('kendoSwitch').check();
        if (!hasTarget && !includeIntersection) {
            errors.push({
                selector: '#' + this._id('first-source-target-fields') + ',#' + this._id('second-source-target-fields'),
                message: this.resourcesHandler.get('Analysis_ValidationTargetFields')
            });
        }
        return errors;
    }

    _buildAnalysisPayload() {
        const firstEntity = this._selectedRow('first-source');
        const secondEntity = this._selectedRow('second-source');
        const firstGeom = this._selectedRow('first-source-fields');
        const secondGeom = this._selectedRow('second-source-fields');
        const includeIntersection = this._$('include-intersection-geom').data('kendoSwitch').check();

        const data = {
            analyseType: 'Complex',
            dataSource: {
                joins: [{
                    joinType: this._combo('join-type').value(),
                    rightDataSource: {},
                    filter: {
                        items: [
                            {
                                type: "condition",
                                leftValue: {},
                                rightValue: {},
                                operator: this._combo('spatial-operator').value()
                            }
                        ]
                    }
                }]
            },
            outputValues: [],
            layerName: this._$('analysis-name').val() === ''
                ? this._defaultLayerName()
                : this._$('analysis-name').val(),
            pkField: this._combo('analysis-pk-field').value(),
            geomField: this._combo('analysis-geom-field').value(),
            bboxStrategy: this._$('spatial-filter').data('kendoSwitch').check()
        };

        this._applySource(data.dataSource, firstEntity);
        
        this._applySource(data.dataSource.joins[0].rightDataSource, secondEntity);
        data.dataSource.joins[0].filter.items[0].leftValue = {
            type: "Field",
            dataSourceKey: firstEntity.Key,
            fieldName: this._selectedRow('first-source-fields').FieldName
        };
        data.dataSource.joins[0].filter.items[0].rightValue = {
            type: "Field",
            dataSourceKey: secondEntity.Key,
            fieldName: this._selectedRow('second-source-fields').FieldName
        };

        this._collectTargetFields(firstEntity, 'first-source-fields', 'first-source-target-field-items', data.outputValues);
        this._collectTargetFields(secondEntity, 'second-source-fields', 'second-source-target-field-items', data.outputValues);

        if (includeIntersection) {
            data.outputValues.push({
                outputName: this._intersectionOutputName(firstEntity, secondEntity),
                type: 'Expression',
                key: 'geomIntersection',
                parameters: [
                    {
                        key: 'GEOM_1',
                        value: this._fieldRef(firstEntity, firstGeom)
                    },
                    {
                        key: 'GEOM_2',
                        value: this._fieldRef(secondEntity, secondGeom)
                    }
                ] 
            });
        }

        return data;
    }
}
